export class Lookup {
   id: string;
   name: string;
   lastModifiedBy: string;
   lastModifiedDate: Date;
   description: string;
   defaultValue: string;
   languageItems: LanguageItem[];
}

export interface LanguageItem {
   languageStaticData: LanguageStatic[];
}

export interface LanguageStatic {
   language: string;
   items: Item;
}

export interface Item {
   choiceDataSourceEntity: ChoiceDataSourceEntity[];
}

export interface ChoiceDataSourceEntity {
   id: string;
   isDefaultValue: boolean;
   displayMember: string;
   valueMember: string;
}
